import { isArray, isObject } from "@/common/utils";

export class Base {
  protected _propertyNames: Array<string> = []; //to be overwritten in extended class

  protected get DisplayWidth() : number {
    return 200;
  }

  protected get DeviceLanguage() : string {
    let lang = 'th';
    if (navigator) {
      lang = navigator.language.split('-')[0].toLowerCase();
    }
    return lang;
  }
  
  /**
   * serialize properties to simple JSON object for http request
   */
  /*protected getBody(mapping:{[key:string] : string}) : {[key:string] : any} {
    let properties:{[key:string] : any} = {};
    let propertyNames:string[] = this._propertyNames;
    let body: {[key:string] : any} = {};
    mapping = mapping || {};
    for (let p in mapping) {
      if (this._propertyNames.indexOf(p)>=0) {
        let p2 = mapping[p];
        body[mapping[p]] = 
      }
    }
    return body;
  }*/
  /**
   * serialize properties to JSON object for data exchange
   */
  protected getProperties(propertyNames?:Array<string>) : {[key:string] : any} {
    let properties:{[key:string] : any} = {};
    propertyNames = propertyNames || this._propertyNames;
    propertyNames.forEach((pn) => {
      let p = this[pn];
      if (p !== undefined) {
        if (p && isArray(p) && p.length>0 && isObject(p[0])) {
          //Array of Object
          properties[pn] = p.map((o) => {
            if (o.Properties!==undefined) {
              return o.Properties;
            } else {
              let ov = {};
              for (let k in o) {
                ov[k] = o[k];
              }
              return ov;
            }
          },this);
        } else if (p && isObject(p)) {
          //Object
          if (p.Properties!==undefined) {
            properties[pn] = p.Properties;
          } else {
            properties[pn] = {};
            for (let k in p) {
              properties[pn][k] = p[k];
            }
          }
        } else {
          properties[pn] = p;
        }
      }
    }, this);
    return properties;
  }

  /**
   * Inheritated class should overwritten these
   */
  protected set Properties(obj:{[key:string] : any}) {}
  protected get Properties() : {[key:string] : any} {
    return this.getProperties();
  }
}